"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var colors_1 = require("../colors");

var dark = {
  palette: {
    text: {
      "default": colors_1.colors.solid.zircon,
      secondary: colors_1.colors.solid.comet,
      tertiary: colors_1.colors.solid.white,
      contrast: colors_1.colors.solid.vulcan
    },
    background: {
      "default": colors_1.colors.solid.vulcan,
      secondary: colors_1.colors.solid.vulcanLightest,
      tertiary: colors_1.colors.solid.cometDark,
      alternate: colors_1.colors.solid.bunker,
      contrast: colors_1.colors.solid.zirconDark
    },
    border: {
      "default": colors_1.colors.solid.cometDark,
      secondary: colors_1.colors.solid.cometDarkest,
      tertiary: colors_1.colors.solid.cometDarkest,
      contrast: colors_1.colors.solid.zirconDarkest
    }
  }
};
exports["default"] = dark;